import script from "./SyncOptionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncOptionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SyncOptionsPage.vue?vue&type=style&index=0&id=587fdc49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587fdc49"]])

export default __exports__